import { CUSTOM_COIN_ICONS, SYNCED_COIN_ICONS } from "./coinIconManifest";

// Token icon utilities
// Icons are served from /public/assets/coins/{symbol}.svg
// Sync icons with: bun run sync:coins (also regenerates coinIconManifest.ts)
//
// Custom overrides go in /public/assets/coins-custom/
// Add mappings below to use custom icons for specific tokens

// Override mappings: token symbol -> custom icon filename (without extension)
// The custom icon should be placed in /public/assets/coins-custom/
// Example: { "MYTOKEN": "my-custom-icon" } -> /public/assets/coins-custom/my-custom-icon.svg
export const TOKEN_ICON_OVERRIDES: Record<string, string> = {
	btc: "btc",
	eth: "eth",
	altcoin: "altcoin",
	stablecoin: "stablecoin",
};

export function normalizeTokenDisplaySymbol(symbol: string): string {
	const upperSymbol = symbol.trim().toUpperCase();
	if (upperSymbol === "WETH") return "ETH";
	return upperSymbol;
}

// Get the icon path for a token
// Checks overrides first, then falls back to synced icons
export function getTokenIconPath(symbol: string): string {
	const displaySymbol = normalizeTokenDisplaySymbol(symbol);
	const lowerSymbol = displaySymbol.toLowerCase();
	const override = TOKEN_ICON_OVERRIDES[displaySymbol] || TOKEN_ICON_OVERRIDES[lowerSymbol];

	if (override) {
		return `/assets/coins-custom/${override}.svg`;
	}

	return `/assets/coins/${lowerSymbol}.svg`;
}

export function hasTokenIcon(symbol: string): boolean {
	const displaySymbol = normalizeTokenDisplaySymbol(symbol);
	const lowerSymbol = displaySymbol.toLowerCase();
	const override = TOKEN_ICON_OVERRIDES[displaySymbol] || TOKEN_ICON_OVERRIDES[lowerSymbol];

	if (override) {
		return CUSTOM_COIN_ICONS.has(override);
	}

	return SYNCED_COIN_ICONS.has(lowerSymbol);
}

// Color palette for fallback badges (deterministic based on token symbol)
const FALLBACK_COLORS = [
	"#6366f1", // indigo
	"#8b5cf6", // violet
	"#d946ef", // fuchsia
	"#ec4899", // pink
	"#f43f5e", // rose
	"#ef4444", // red
	"#f97316", // orange
	"#eab308", // yellow
	"#84cc16", // lime
	"#22c55e", // green
	"#14b8a6", // teal
	"#06b6d4", // cyan
	"#0ea5e9", // sky
	"#3b82f6", // blue
];

// Generate a consistent color for a token symbol
export function getTokenColor(symbol: string): string {
	let hash = 0;
	for (let i = 0; i < symbol.length; i++) {
		hash = symbol.charCodeAt(i) + ((hash << 5) - hash);
	}
	return FALLBACK_COLORS[Math.abs(hash) % FALLBACK_COLORS.length];
}
